import { _, init, addMessages, locale } from 'svelte-i18n';
import en from '../../src/lang/en.json';
import fr from '../../src/lang/fr.json';

addMessages('en', en);
addMessages('fr', fr);

const fallbackLocale = 'en';

function initI18n() {
	init({
		fallbackLocale: fallbackLocale
	});
	const navigatorLanguage = window.navigator.language?.split('-');
	locale.set(navigatorLanguage[0]);
}

initI18n();
export { _, fallbackLocale, locale };
